<section class="tw-pb-2 tw-p-4 tw-m-4 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-rounded-xl tw-overflow-hidden" style="background: white !important">
  <div class="tw-flex tw-gap-4 tw-mb-4" *ngIf="showReorderKitHeader">
      <span class="tw-relative tw-inline-block tw-flex-shrink-0">
        <img alt="dr" class="tw-flex-none tw-h-12 tw-w-12 tw-border tw-rounded-full" [src]="userDrImage" />
        <img alt="tick" src="/assets/icons/orange_tick_new.svg" class="tw-absolute tw-top-1 tw-right-[-4px] tw-h-4 tw-w-4">
      </span>
    <span>
      <h2 class="tw-font-bold tw-text-500 tw-text-black tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@reorderYourKit">Reorder your kit</h2>
      <p class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@toAvoidGapsInTreatment">To avoid gaps in your treatment</p>
      </span>
  </div>
  <div class="tw-flex tw-gap-4 tw-mb-4" *ngIf="showDoctorAddedHeader">
      <span class="tw-relative tw-inline-block tw-flex-shrink-0">
        <img alt="dr" class="tw-flex-none tw-h-12 tw-w-12 tw-border tw-rounded-full" [src]="userDrImage" />
        <img alt="tick" src="/assets/icons/orange_tick_new.svg" class="tw-absolute tw-top-1 tw-right-[-4px] tw-h-4 tw-w-4" id="tick">
      </span>
      <span>
          <h2 class="tw-font-bold tw-text-500 tw-text-gray-800 tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@drAddedProducts">
              Doctor-added products
          </h2>
          <p class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@basisCheckupReport">
              Based on your checkup report
          </p>
      </span>
  </div>
  <div class="tw-flex tw-gap-6 tw-mb-4" *ngIf="showCompleteOrderHeader">
    <span>
        <h2 class="tw-font-bold tw-text-500 tw-text-gray-800 tw-tracking-normal" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@completeOrder">
            Complete your order
        </h2>
        <p class="tw-font-body tw-text-300 tw-text-gray-500" i18n="@@multipleProductsInCart">
            {{ numberOfProductsInCart ? numberOfProductsInCart : toolbarIcons[1].cartValue }} Products in your cart
        </p>
    </span>
  </div>
  <div class="tw-flex tw-mb-2 tw-w-full tw-overflow-auto tw-gap-[4px] hide-scrollbar" (click)="handleClick()">
    <div class="tw-relative tw-flex tw-flex-col tw-flex-shrink-0 tw-items-start tw-w-[100px]" *ngFor="let product of productsInCart">
      <div class="tw-flex tw-relative tw-overflow-hidden tw-mb-2 tw-w-[80px] tw-h-[100px]">
        <img alt="product" class="tw-w-full tw-h-full tw-rounded-2 tw-object-contain" [src]="
          product?.rebrandedImageWithBackground ||
          product?.rebrandedImageWithoutBackground ||
          product?.productUnboxedImage
        " />
        <div class="tw-flex tw-flex-row tw-rounded-br-2 tw-rounded-bl-2 tw-items-center tw-justify-center tw-gap-1 tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-bg-orange-100" *ngIf="product?.isDoctorAdded">
          <cs-icon class="tw-h-3 tw-w-3 tw-text-bold tw-text-orange-400" [iconName]='"done"'></cs-icon>
          <p class="tw-text-orange-400 tw-text-100 tw-whitespace-nowrap" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'" i18n="@@drAdded">
            Dr. Added
          </p>
        </div>
      </div>
      <p class="tw-flex-none tw-font-lexend tw-text-100 tw-text-left tw-leading-tight tw-mb-1">
        {{ product?.title }}
      </p>
    </div>
  </div>
  <button csButton
          id="cartMultipleProductBannerBuyNowButton"
          type="button"
          class="tw-w-full tw-h-10 tw-gap-[6%] tw-justify-normal tw-overflow-visible tw-px-[14px] tw-mb-2 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]"
          (click)="handleClick()">
          <div class="shine loop tw-absolute tw-inset-0 tw-bg-gradient-to-r tw-from-transparent tw-via-white/50 tw-to-transparent tw-pointer-events-none"></div>
    <div class="tw-flex tw-items-center tw-justify-center tw-text-orange-400">
      <cs-icon class="tw-w-[56px] tw-h-[56px] tw-relative tw-animate-spin_slow" [iconName]='"rebranded-orange-discount"'></cs-icon>
      <div class="tw-absolute tw-uppercase tw-font-bold tw-z-0 tw-leading-4 tw-text-300 tw-text-white" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
        <span>{{ cartDiscount }}%</span> <br /> <span i18n="@@off" class="tw-text-200">Off</span>
      </div>
    </div>
    <span class="tw-font-bold tw-text-300 tw-tracking-normal tw-normal-case" [class]="isShopRevampExperimentOn ? 'tw-font-lexend' : 'tw-font-body'">
      <span i18n="@@buyNow">Buy Now</span><span>&nbsp;&#64; ₹{{ totalSp }}</span>
    </span>
  </button>
</section>
